import React from "react";
import logo from "../assets/loremig-logo-oficial.png";
import { QUIENES } from "../data/content";

export default function QuienesSomos() {
  return (
    <section id="quienes" className="band sage" data-screen-label="02 Quienes Somos">
      <div className="band-bg" />
      <div className="scatter" />
      <div className="tear-top tear-cream-top" />
      <div className="tear-bottom tear-sage-bottom" />

      <div className="wrap">
        <div className="sec-head">
          <h2 className="sec-title">Quiénes somos</h2>
        </div>

        <div className="qs-grid">
          <div>
            <p
              className="lead"
              style={{ color: "var(--cream-soft)" }}
              dangerouslySetInnerHTML={{ __html: QUIENES.leadHtml }}
            />
            {QUIENES.paras.map((p, i) => (
              <p className="body" key={i} style={{ color: "rgba(247,238,217,.88)" }}>
                {p}
              </p>
            ))}
          </div>

          <div className="qs-card">
            <img className="logo" src={logo} alt="LoremiG Party — wordmark vintage estilo pastelería" />
            <div className="caption">{QUIENES.caption}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
